import React, { useRef, useMemo } from "react";
import DataGrid from "devextreme-react/data-grid";
import ItemLotSubTabs from "./ItemLotSubTabs";
import ITEM_LOT_COLUMNS from "./itemLotColumns";

// Master item/lot grid + the lot's detail sub-tabs. Selecting a row pushes it to the sub-tabs via a ref.
// The full Delphi qryIMLot column set lives in itemLotColumns.js (5 visible, rest in the chooser).
function ItemLotSearchResults(props) {
  const detailRef = useRef(null);

  const onSelectionChanged = ({ selectedRowsData }) => {
    const row = selectedRowsData && selectedRowsData.length ? selectedRowsData[0] : null;
    if (detailRef.current) {
      detailRef.current.updateData(row);
    }
  };

  const pager = useMemo(() => ({ visible: true, showPageSizeSelector: true, allowedPageSizes: [20, 50, 100], showInfo: true }), []);

  return (
    <div>
      <div style={{ height: "calc((100vh - 300px) / 2)", marginTop: 8 }}>
        <DataGrid
          dataSource={props.data}
          columns={ITEM_LOT_COLUMNS}
          remoteOperations={true}
          showBorders={true}
          columnAutoWidth={true}
          height="100%"
          sorting={{ mode: "multiple" }}
          filterRow={{ visible: true }}
          headerFilter={{ visible: true }}
          columnChooser={{ enabled: true }}
          export={{ enabled: true }}
          selection={{ mode: "single" }}
          paging={{ pageSize: 20 }}
          pager={pager}
          onSelectionChanged={onSelectionChanged}
        />
      </div>
      <div style={{ marginTop: 8 }}>
        <ItemLotSubTabs ref={detailRef} accessToken={props.accessToken} />
      </div>
    </div>
  );
}

export default ItemLotSearchResults;
